/* eslint-disable max-len */
export default {
  title_pc: 'デザインと技術でユーザーにハピネスを',
  title_sp: 'デザインと技術で\nユーザーにハピネスを',
  description1_pc: '私たち飛狼（フェイラン）は、中国を拠点に\nデザインと技術にこだわったプロダクト開発やサービスを強みとするプロフェッショナル集団です。\n中国から世界へ、最先端ITを駆使して課題を解決し、\n世の中に新たな体験を生むための良きパートナーとなります。',
  description1_sp: '私たち飛狼（フェイラン）は、中国を拠点に\nデザインと技術にこだわった\nプロダクト開発やサービスを強みとする\nプロフェッショナル集団です。\n中国から世界へ、最先端ITを駆使して\n課題を解決し、世の中に新たな体験を生むための\n良きパートナーとなります。',
};
